import { Component, OnInit } from '@angular/core';
import { DataStoreService } from "../shared/services/api/data-store.service";
import { Appointment } from "../shared/models/appointment";
import * as moment from "moment";
import { MatDialog } from "@angular/material";
import { AppointmentCreateComponent } from "../appointment/appointment-create/appointment-create.component";
import {
  AppointmentDetailComponent,
  DialogResult
} from "../appointment/appointment-detail/appointment-detail.component";
import { ActivatedRoute } from "@angular/router";
import { LoadingStateService } from "../shared/services/loading-state.service";
import Moment = moment.Moment;


interface Event {
  title: string,
  start: Moment,
  end: Moment,
  id: number
}

@Component({
  selector: 'app-calendar',
  templateUrl: './calendar.component.html',
  styleUrls: ['./calendar.component.css']
})
export class CalendarComponent implements OnInit {

  public headerConfig: any;

  private appointments: Appointment[] = [];
  public events: Event[] = [];
  private init = false;

  constructor(private dataStore: DataStoreService,
              private route: ActivatedRoute,
              private loadingService: LoadingStateService,
              private dialog: MatDialog) {
  }

  ngOnInit() {
    this.headerConfig = {
      left: 'prev,next today',
      center: 'title',
      right: 'month,agendaWeek,agendaDay'
    };

    this.route.data.subscribe((data: { events: Appointment[] }) => {
      this.appointments = data.events;
      this.events = this.appointments.map(appointment => appointment.calendarEvent);
    });
  }

  loadEvents(event) {
    if (this.init) {
      this.loadingService.setLoading(true);
      this.dataStore.findAll(Appointment, {
        filter: {
          start: event.view.start.toISOString(),
          end: event.view.end.toISOString(),
          all: true
        }
      }).map(doc => doc.getModels())
        .finally(() => this.loadingService.setLoading(false))
        .subscribe(appointments => {
          this.appointments = appointments;
          this.events = this.appointments.map(appointment => appointment.calendarEvent);
        })
    }
    this.init = true;
  }

  openCreateDialog(event = null) {
    let dialogRef = this.dialog.open(AppointmentCreateComponent, {
      data: {
        day: event ? moment(event.date) : moment()
      }
    });
    dialogRef.afterClosed().subscribe((appointment: Appointment) => {
      if (appointment) {
        this.events.push(appointment.calendarEvent);
        this.appointments.push(appointment);
      }
    });
  }

  viewAppointment(event) {
    let appointment = this.appointments.find(appointment => appointment.id == event.calEvent.id);
    let dialogRef = this.dialog.open(AppointmentDetailComponent, {
      data: {
        appointment: appointment
      }
    });
    dialogRef.afterClosed().subscribe((result: DialogResult) => {
      switch (result) {
        case DialogResult.DELETED:
          let eventIdx = this.events.findIndex(event => event.id == parseInt(appointment.id));
          if (eventIdx > -1) {
            this.events.splice(eventIdx, 1);
            this.appointments.splice(this.appointments.indexOf(appointment));
          }
      }
    });
  }

}



// WEBPACK FOOTER //
// /home/markush/Projects/fieldsale-wingman-client/src/app/calendar/calendar.component.ts